var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"parentElement",style:(_vm.styles.reactionContainer)},_vm._l((Array(6).fill(0)),function(_,i){return _c('span',{key:i,staticClass:"live__reaction__emoji",style:(_vm.styles.reactionEmoji)},[_c('img',{attrs:{"src":_vm.reactionIconSrc,"alt":_vm.reaction}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }